import Route from '@ember/routing/route';

export interface JournalParams {
  journalId: string;
}

export default class JournalRoute extends Route {}
